<template>
  <a-modal
    class="user-delete-modal"
    :title="$t('User_Del1')"
    :visible="visible"
    :maskClosable="false"
    centered
    @cancel="handleCancel"
  >
    <!-- custom footer -->
    <template v-slot:footer>
      <a-button key="back" @click="handleCancel">{{$t("Common_Cancel")}}</a-button>
      <a-button
        key="submit"
        class="delete-btn"
        :loading="loading"
        @click="handleOk"
      >
        {{$t("Common_Delete")}}
      </a-button>
    </template>

    <!-- contents -->
    <div class="content-text">
      <div>{{$t('User_Del2')}}</div>
      <div>{{$t('User_Del3')}}</div>
    </div>
    <div class="content-group">
      <ul>
        <li>
          <span class="title">No</span>
          <span class="value">{{ userInfo.userNo }}</span>
        </li>
        <li>
          <span class="title">{{$t("User_Del4")}}</span>
          <span class="value">{{ userInfo.userName }}</span>
        </li>
        <li>
          <span class="title">{{$t("Common_RegDate")}}</span>
          <span class="value">{{
            timeFormatFromUTCEpoch(userInfo.regEpoch)
          }}</span>
        </li>
      </ul>
    </div>
  </a-modal>
</template>

<script>
import { computed, ref } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import { apiUrl, timeFormatFromUTCEpoch } from "@/utils/common";
import InputComponent from "@/components/commonComponents/InputComponent";

export default {
  name: "UserDeleteModal",
  props: {
    mode: String,
    visible: Boolean,
    userInfo: Object,
    toggleModal: Function,
  },
  components: {
    InputComponent,
  },
  setup(props) {
    const store = useStore();

    const loading = ref(false);

    // 취소 버튼 이벤트
    const handleCancel = () => {
      props.toggleModal();
    };

    // 삭제 버튼 이벤트
    const handleOk = async () => {
      loading.value = true;

      try {
        const params = {
          userNo: props.userInfo.userNo,
        };
        const response = await axios.delete(apiUrl + "User", { params });
        if (response && !response.data.error) {
          store.dispatch("user/DELETE_USER", response);
        }
      } catch (error) {
        console.log("delete user error", error);
      }

      loading.value = false;
      props.toggleModal();
    };

    return {
      loading,
      handleCancel,
      handleOk,
      timeFormatFromUTCEpoch,
    };
  },
};
</script>